import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { Router } from '@angular/router'
import { EnrollmentCountModel } from '../../../models/enrollment-count.model'
import { ReportsGateway } from '../../../gatewasys/reports.gateway'
import * as _ from 'lodash'
import { ExcelService } from '../../../excel.service'
import { MyClientsCriteria } from '../../../models/my-clients-criteria'
import { PortalGlobals } from '../../../../portalglobals'

@Component({
    selector: 'NEJEEnrollmentCountsReport',
    templateUrl: './enrollment-counts-report.component.html'
})
export class NEJEEnrollmentCountsReportComponent implements OnInit {
    public loading = false
    //width: number = 1040;
    isSummary: boolean = false
    myClientsCriteria: MyClientsCriteria
    enrollmentCounts: EnrollmentCountModel[] = [] as EnrollmentCountModel[]
    enrollmentEffectiveDate: string
    @ViewChild('TreeGrid') countsGrid: jqxGridComponent
    @ViewChild('reportStart') reportStart: ElementRef
    errorMessage: string
    isOrgPresent: boolean = false
    reportType: string
    showCountReport: boolean = true

    jqx: any
    source: any = {
        dataFields: [
            { name: 'PlanName', type: 'string' },
            { name: 'TierTranslation', type: 'string' },
            { name: 'Submitted', type: 'number' },
            { name: 'Enrolled', type: 'number' },
            { name: 'Disenrolled', type: 'number' },
            { name: 'Denied', type: 'number' },
            { name: 'Pending', type: 'number' },
            { name: 'Cancelled', type: 'number' },
            { name: 'CorrectionNeeded', type: 'number' },
            { name: 'StateAbbr', type: 'string' }
        ],
        dataType: 'json',
        localData: this.enrollmentCounts
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    countRenderer = function (row, columnfield, value, id) {
        return '<div class="jqx-grid-cell-left-align"><a>' + value + '</a></div>'
    }

    ngOnInit() {
        ;(<HTMLElement>document.getElementsByClassName('search-criteria')[0]).style.display = 'block'
        this.loading = true

        this.myClientsCriteria = this._reportsGateway.myClientsCriteria

        if (
            ((this.myClientsCriteria.OrgList === '' || this.myClientsCriteria.OrgList === null || this.myClientsCriteria.OrgList === undefined) &&
                (this.myClientsCriteria.AgentID === '0' || this.myClientsCriteria.AgentID === '')) ||
            this.myClientsCriteria.IsClearReport
        ) {
            this.loading = false
            this.showCountReport = false
        } else {
            this.delay(5000)
            this.getEnrollmentCounts()
            this.showCountReport = true
        }
    }

    async delay(ms: number) {
        await new Promise((resolve) => setTimeout(() => resolve(''), 1000)).then(() => console.log('fired'))
    }

    columns: any[] = [
        { text: 'Plan Type', dataField: 'PlanName', width: 300 },
        { text: 'State', dataField: 'StateAbbr', width: 150 },
        {
            text: 'Submitted',
            dataField: 'Submitted',
            width: 110,
            cellsrenderer: this.countRenderer
        },
        { text: 'Enrolled', dataField: 'Enrolled', width: 100, cellsrenderer: this.countRenderer },
        { text: 'Disenrolled', dataField: 'Disenrolled', width: 115, cellsrenderer: this.countRenderer },
        { text: 'Denied', dataField: 'Denied', width: 90, cellsrenderer: this.countRenderer },
        { text: 'Pending', dataField: 'Pending', width: 90, cellsrenderer: this.countRenderer },
        { text: 'Cancelled', dataField: 'Cancelled', width: 105, cellsrenderer: this.countRenderer },
        { text: 'Correction Needed', dataField: 'CorrectionNeeded', width: 170, cellsrenderer: this.countRenderer }
    ]

    Cellclick(event: any): void {
        if (event.args.datafield !== 'PlanName' && event.args.datafield !== 'StateAbbr') {
            if (event.args.row.bounddata.PlanName === 'Totals') {
                this.myClientsCriteria.Plans = 'ALL'
            } else {
                this.myClientsCriteria.Plans = event.args.row.bounddata.TierTranslation
            }

            if (event.args.value > 0) {
                if (event.args.datafield === 'CorrectionNeeded') {
                    this.myClientsCriteria.ReportCategory = 'Correction Needed'
                } else {
                    this.myClientsCriteria.ReportCategory = event.args.datafield
                }

                this.myClientsCriteria.StateAbbr = event.args.row.bounddata.StateAbbr
                localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))

                //localStorage.setItem('clientCriteria', JSON.stringify(this._reportsGateway.myClientsCriteria))
                const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                this._routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients/summary')
            }

            //this._routers.navigateByUrl('/reports/enrollments-summary/' +
            //	event.args.row.bounddata.PlanName + '/' + event.args.datafield)
        }
    }

    constructor(
        private _routers: Router,
        private _excelService: ExcelService,
        private _reportsGateway: ReportsGateway,
        public _global: PortalGlobals
    ) {}

    onExport() {
        let array = _.clone(this.enrollmentCounts)
        array.forEach(function (v) {
            delete v.PlanID
            delete v.TierTranslation
            delete v.Message
        })
        let strArray = JSON.stringify(array)
        strArray = strArray.replace(/PlanName/g, 'Plan Type')
        strArray = strArray.replace(/CorrectionNeeded/g, 'Correction Needed')
        strArray = strArray.replace(/StateAbbr/g, 'State')
        let counts = JSON.parse(strArray)
        this._excelService.exportAsExcelFile(counts, 'My Clients Report')
    }

    onPrint() {
        let gridContent = this.countsGrid.exportdata('html')
        let newWindow = window.open('', '', 'width=800, height=500'),
            document = newWindow?.document.open(),
            pageContent =
                '<!DOCTYPE html>\n' +
                '<html>\n' +
                '<head>\n' +
                '<meta charset="utf-8" />\n' +
                '<title>Enrollment Counts</title>\n' +
                '</head>\n' +
                '<body>\n' +
                gridContent +
                '\n</body>\n</html>'
        document?.write(pageContent)
        document?.close()
        newWindow?.print()
    }

    onBack() {}

    onGetTemporaryIDCard() {}

    onPageSizeChanged(event: any): void {
        let args = event.args
        this.source.pagesize = this.myClientsCriteria.PageSize = args.pagesize
        this._reportsGateway.getEnrollmentsCount(this.myClientsCriteria).subscribe((counts) => {
            this.source.localdate = counts
            this.dataAdapter.dataBind()
            this.countsGrid.updatebounddata()
        })
    }

    getEnrollmentCounts() {
        //this.myClientsCriteria = (localStorage.getItem('clientCriteria') !== null) ? JSON.parse(localStorage.getItem('clientCriteria')) : this.myClientsCriteria
        if (this.myClientsCriteria === undefined || this.myClientsCriteria === null || this.myClientsCriteria.OrgID === 0) {
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
        }
        this._reportsGateway.getEnrollmentsCount(this.myClientsCriteria).subscribe(
            (counts) => {
                let eCount = new EnrollmentCountModel()
                if (counts.length > 0 && counts[0].Message !== undefined && counts[0].Message !== '' && counts[0].Message !== null) {
                    eCount.Message = counts[0].Message
                    this.isOrgPresent = true
                } else {
                    this.isOrgPresent = false
                    eCount.PlanName = 'Totals'
                    eCount.Cancelled = _.sumBy(counts, 'Cancelled')
                    eCount.CorrectionNeeded = _.sumBy(counts, 'CorrectionNeeded')
                    eCount.Denied = _.sumBy(counts, 'Denied')
                    eCount.Disenrolled = _.sumBy(counts, 'Disenrolled')
                    eCount.Enrolled = _.sumBy(counts, 'Enrolled')
                    eCount.Pending = _.sumBy(counts, 'Pending')
                    eCount.Submitted = _.sumBy(counts, 'Submitted')

                    counts.push(eCount)
                    this.enrollmentCounts = counts
                    this.source.localdata = this.enrollmentCounts
                    this.dataAdapter.dataBind()
                    this.countsGrid.updatebounddata()
                    setTimeout(() => this.countsGrid.focus(), 50)
                }
                this.loading = false
            },
            (error) => {
                this.loading = false
                this.errorMessage = 'Failed to load the report'
                this.reportStart.nativeElement.focus()
            }
        )
    }
}
